import IndustrialExcessLandfillData from "../../../../src/components/industrial-excess-landfill-data.js";
import * as React from 'react';
export default {
  IndustrialExcessLandfillData,
  React
};